import React from 'react';
import './loadingOverlay.css'

const LoadingOverlay = (props) => {
    let style = {
        color: "#012E40",
        fontSize: "18px",
        textAlign: "center"
    }
    const ProgressBar = ({ width }) => (
        <div className="outer">
            <div
                className="inner"
                style={{
                    width: `${width}%`
                }}
            />
        </div>
    )
    return (
        <div className="contentLoader">
            <div className="modalContent">
                <div className="textInfo">
                    <p style={style}>{props.text}</p>
                    <div className='loader'></div>
                    {
                        props.showProgress && <div className="containerBarraProgreso">
                            <h2>{props.progress == 100 ? `Carga Completada!` : `${props.progress}%`}</h2>
                            <ProgressBar width={props.progress} />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default LoadingOverlay;
